import { IBenefitBalance, IBenefitTransaction } from "@edp-models/benefits-transaction.model";
import {
    CardType,
    Card,
    Filter,
    IBenefitsCounter,
    ExclusiveBenefitsCard,
    IBenefitsUserDetails,
    AvailableOfferFilter,
} from "@edp-models/benefits.model";

export interface IBenefitsState {
    cards: Card[];
    generatedCodeCards: Card[];
    cardTypes: CardType[];
    filters: Filter[];
    loadedCards: boolean;
    reloadFilters: boolean;
    errorBenefits: boolean;
    shareModal: boolean;
    counterPartnerBenefits: IBenefitsCounter;
    codeValidity: any;
    exclusiveBenefitsCards: ExclusiveBenefitsCard[];
    benefitsUsers: IBenefitsUserDetails[];
    transactions: IBenefitTransaction[];
    balance: IBenefitBalance;
    benefitUserSelected: IBenefitsUserDetails;
    districts: any[];
    availableOffers: Card[];
    availableOffersFilter: AvailableOfferFilter;
}

export const initialBenefitsState: IBenefitsState = {
    cards: [],
    benefitsUsers: [],
    generatedCodeCards: [],
    cardTypes: [],
    filters: [],
    errorBenefits: false,
    loadedCards: false,
    reloadFilters: false,
    shareModal: false,
    counterPartnerBenefits: null,
    codeValidity: null,
    exclusiveBenefitsCards: [],
    transactions: null,
    balance: null,
    benefitUserSelected: null,
    districts: [],
    availableOffers: [],
    availableOffersFilter: null,
};
